import { h } from 'preact'
import { useState } from 'preact/hooks'
import { createSupportEmail } from '../beacon-api.js'
import { t } from '../beacon-i18n.js'

/**
 * EmailScreen — subject + body compose form, POSTs to
 * /support/widget/conversations (see plan "Support widget API").
 */
export function EmailScreen({ store }) {
  const [subject, setSubject] = useState('')
  const [body, setBody] = useState('')
  const [sending, setSending] = useState(false)
  const [error, setError] = useState(false)
  const [sent, setSent] = useState(false)

  async function handleSubmit(event) {
    event.preventDefault()
    if (!body.trim() || sending) return

    setSending(true)
    setError(false)
    try {
      await createSupportEmail({ subject: subject.trim(), body: body.trim() })
      setSent(true)
      setSubject('')
      setBody('')
    } catch {
      setError(true)
    } finally {
      setSending(false)
    }
  }

  if (sent) {
    return (
      <div class="beacon-email-sent">
        <i class="bi bi-check-circle-fill"></i>
        <p>{t('support.beacon.email.sent_message')}</p>
        <button type="button" class="beacon-email-sent-history-btn" onClick={() => store.navigateTo('conversations')}>
          {t('support.beacon.email.sent_history_btn')}
        </button>
      </div>
    )
  }

  return (
    <form class="beacon-email-screen" onSubmit={handleSubmit}>
      <p class="beacon-email-intro">{t('support.beacon.email.intro')}</p>

      <label class="beacon-email-field">
        <span>{t('support.beacon.email.subject_label')}</span>
        <input
          type="text"
          value={subject}
          onInput={(e) => setSubject(e.currentTarget.value)}
          placeholder={t('support.beacon.email.subject_placeholder')}
        />
      </label>

      <label class="beacon-email-field beacon-email-field-body">
        <span>{t('support.beacon.email.body_label')}</span>
        <textarea
          value={body}
          onInput={(e) => setBody(e.currentTarget.value)}
          placeholder={t('support.beacon.email.body_placeholder')}
          rows={6}
        ></textarea>
      </label>

      {error && (
        <div class="beacon-email-error">
          <i class="bi bi-exclamation-triangle-fill"></i> {t('support.beacon.email.error')}
        </div>
      )}

      <button type="submit" class="beacon-email-send-btn" disabled={sending || !body.trim()}>
        {sending ? t('support.beacon.email.sending_btn') : t('support.beacon.email.send_btn')}
      </button>
    </form>
  )
}
